import { OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { UsuariosService } from '../_services';
import { first } from 'rxjs/operators';
import { CaptchaComponent } from 'angular-captcha';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal/bs-modal.service';
var RegistroComponent = /** @class */ (function () {
    function RegistroComponent(formBuilder, usuariosService, route, router, modalService) {
        this.formBuilder = formBuilder;
        this.usuariosService = usuariosService;
        this.route = route;
        this.router = router;
        this.modalService = modalService;
        this.submitted = false;
        this.loading = false;
        this.alerta = '';
        this.suscripciones = [];
        this.aceptado = false;
        this.esRegistro = !!route.snapshot.data['registro'];
    }
    Object.defineProperty(RegistroComponent.prototype, "f", {
        // convenience getter for easy access to form fields
        get: function () {
            return this.registroForm.controls;
        },
        enumerable: true,
        configurable: true
    });
    RegistroComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.registroForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required],
            nombre: ['', Validators.required],
            apellido: ['', Validators.required],
            celular: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            numero_documento: ['', [Validators.required]],
            captchaCode: [''],
            captchaId: [''],
            aceptado: ['']
        });
        if (!this.esRegistro) {
            this.registroForm.addControl('notificar_sms', new FormControl('', Validators.nullValidator));
            this.registroForm.addControl('notificar_email', new FormControl('', Validators.nullValidator));
            this.registroForm.addControl('notificar_dispositivo', new FormControl('', Validators.nullValidator));
            this.usuariosService.getCurrentUserInfo().subscribe(function (data) {
                _this.user = data;
                _this.registroForm.controls.nombre.setValue(_this.user.nombre);
                _this.registroForm.controls.apellido.setValue(_this.user.apellido);
                _this.registroForm.controls.username.setValue(_this.user.username);
                _this.registroForm.controls.email.setValue(_this.user.email);
                _this.registroForm.controls.celular.setValue(_this.user.celular);
                _this.registroForm.controls.numero_documento.setValue(_this.user.numero_documento);
                _this.registroForm.controls.password.setValidators([
                    Validators.nullValidator
                ]);
                _this.registroForm.controls.password.updateValueAndValidity();
                _this.registroForm.setValidators(_this.passwordMatchValidator);
                _this.registroForm.controls.notificar_sms.setValue(_this.user.notificar_sms);
                _this.registroForm.controls.notificar_email.setValue(_this.user.notificar_email);
                _this.registroForm.controls.notificar_dispositivo.setValue(_this.user.notificar_dispositivo);
            });
            this.registroForm.addControl('newPassword', new FormControl('', Validators.nullValidator));
            this.registroForm.addControl('confirmPassword', new FormControl('', Validators.nullValidator));
            this.getSuscripciones();
        }
    };
    RegistroComponent.prototype.onSubmit = function () {
        var _this = this;
        this.submitted = true;
        // stop here if form is invalid
        if (this.registroForm.invalid) {
            return;
        }
        this.loading = true;
        this.alerta = '';
        if (this.esRegistro) {
            // cargo los campos del formulario en base al captchaComponent, para que se envíen con el formulario
            this.registroForm.controls.captchaCode.setValue(this.captchaComponent.captchaCode);
            this.registroForm.controls.captchaId.setValue(this.captchaComponent.captchaId);
            this.usuariosService
                .registrar(this.registroForm.value)
                .pipe(first())
                .subscribe(function (data) {
                console.log('Registration successful');
                _this.loading = false;
                alert('¡Gracias por registrarte! Estamos procesando tus datos.');
                _this.router.navigate(['/inicio']);
                // reload Captcha image
                _this.captchaComponent.reloadImage();
            }, function (error) {
                console.error(error);
                _this.alerta = error;
                _this.loading = false;
                // reload Captcha image
                _this.captchaComponent.reloadImage();
            });
        }
        else {
            this.usuariosService
                .editarUsuario(this.registroForm.value)
                .pipe(first())
                .subscribe(function (data) {
                console.log('Edit successful');
                _this.loading = false;
                _this.alerta = '';
                alert('Se han guardado correctamente los cambios realizados.');
                _this.router.navigate(['/inicio']);
            }, function (error) {
                console.error(error);
                _this.alerta = error;
                _this.loading = false;
            });
        }
    };
    RegistroComponent.prototype.onClosed = function (dismissedAlert) {
        this.alerta = '';
    };
    RegistroComponent.prototype.passwordMatchValidator = function (g) {
        if (g.get('newPassword').value === g.get('confirmPassword').value) {
            g.controls['newPassword'].setErrors(null);
            return null;
        }
        else {
            g.controls['newPassword'].setErrors({ mismatch: true });
            return { mismatch: true };
        }
    };
    RegistroComponent.prototype.getSuscripciones = function () {
        var _this = this;
        this.usuariosService
            .getUsuarioSuscripciones()
            .subscribe(function (data) {
            _this.suscripciones = data;
        });
    };
    RegistroComponent.prototype.eliminarDispositivo = function (id) {
        var _this = this;
        if (!confirm('¿Desea eliminar la suscripción de este dispositivo?')) {
            return false;
        }
        this.usuariosService.deleteUsuarioSuscripcion(id).subscribe(function (data) {
            alert('Se elimino correctamente la suscripción');
            _this.getSuscripciones();
        });
    };
    RegistroComponent.prototype.onAceptadoChange = function (event) {
        this.aceptado = !this.aceptado;
    };
    RegistroComponent.prototype.openModal = function (template) {
        this.modalRef = this.modalService.show(template);
    };
    return RegistroComponent;
}());
export { RegistroComponent };
